// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Y0-z","colorTextValue":"Z0-z","swatches":"_0-z","collapseLink":"a1-z","isCollapsed":"b1-z","dropdown":"c1-z","disabled":"d1-z"};